const React = require('react');
const { createElement: h } = React;

function SparkleIcon(props) {
  var size = props && props.size ? props.size : 18;
  var className = props && props.className ? props.className : '';

  return h('svg', {
    className: className,
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true'
  },
    h('path', { d: 'M12 3.5l1.85 4.65L18.5 10l-4.65 1.85L12 16.5l-1.85-4.65L5.5 10l4.65-1.85L12 3.5z' }),
    h('path', { d: 'M18.5 4.75v2.5' }),
    h('path', { d: 'M19.75 6h-2.5' }),
    h('path', { d: 'M4.75 17.5v2' }),
    h('path', { d: 'M5.75 18.5h-2' })
  );
}

module.exports = SparkleIcon;
